// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h2 {
  margin-bottom: 0;
  padding-bottom: 0;
  color: rgba(0, 0, 0, 0.57);
}

h2.ngorange {
  color: rgb(227, 94, 36);
}

.fullView-wrapper {
  padding-bottom: 200px !important;
}

#recordTypeSubTitle {
  font-size: 8pt;
  margin-top: -3px;
}

.panelHr {
  margin: 12px;
}

.name {
  font-size: 1.4rem;
  text-transform: uppercase;
  margin: 0;
  padding: 0;
}

.graph-container {
  min-height: 605px;
  max-width: 100%;
}

.cardEvaluationTitle {
  font-size: 85%;
  text-align: center;
  margin: 0;
  padding: 0;
}

.activeTab {
  background: #dddddd;
  padding: 5px;
  font-size: 1.3rem;
}

.reportStatus {
  padding-top: 20px;
  text-align: center;
}

::ng-deep .reportStatus .mat-mini-fab {
  width: 50px;
  height: 50px;
  color: #ffffff;
  font-size: 2rem;
  padding-top: 2px;
}

.mat-greenIcon {
  background: #78c7af !important;
}

.mat-redIcon {
  background: #f07b7e !important;
}

.mat-yellowIcon {
  background: #efce7c !important;
}

.mat-darkGrayIcon {
  background: #848484 !important;
}

.mat-grayIcon {
  background: #cccccc !important;
}

.mat-orangeIcon {
  background: rgb(227, 94, 36) !important;
}

.prbDate {
  padding: 0 5px;
}

#iacBox {
  background: white;
  border: 4px solid #cecece;
  padding: 20px;
  margin: 10px 0;
  width: 100%;
}

.resultBlock {
  font-size: 14pt;
  padding: 7px 0;
  margin-bottom: 10px;
}

.clear {
  clear: both;
  display: inline;
}

.alignLeft {
  position: absolute;
  left: 2px;
}

.alignRight {
  position: absolute;
  right: 2px;
}

.floatLeft {
  float: left;
}

.floatRight {
  float: right;
}

.dateDiv {
  position: absolute;
  right: 17px;
}

.loaderSpan {
  display: inline-block;
}

.satelliteDescription {
  font-size: 1rem;
  text-align: justify;
}

.reportWrapper {
  margin-bottom: 0px;
}

.footer {
  bottom: 0;
}

::ng-deep .satelliteJobsChoice .mat-form-field {
  width: 233px;
}

::ng-deep .mat-grid-tile.person-name-left-align > .mat-grid-tile-content {
  justify-content: flex-start !important;
  padding: 17px !important;
}

/******************************************** */
.sherpa-padding {
  padding-left: 17px;
  padding-right: 17px;
}

.activate-sherpa-container {
  position: relative;
  padding: 6px 10px 6px 17px;
  border-radius: 2px;
  background: #4D5056;
  width: 100%;
  margin: 0 auto;
}
.activate-sherpa-container .activate-sherpa-text {
  font-family: "Arial";
  color: #fff;
  font-size: 15px;
  line-height: 24px;
  padding: 4px 0;
}
.activate-sherpa-container .activate-sherpa-text .bold-jil {
  font-weight: 700;
}
.activate-sherpa-container .sherpa-nouveau {
  position: absolute;
  margin-top: 16px;
  top: -29px;
  left: 12px;
  border-radius: 18px;
  border: 1px solid #FFF;
  background: radial-gradient(221.49% 177.12% at -46.77% 47.5%, #DFDAD4 10.96%, #FE5E2C 48.6%, #575757 99.99%);
  padding: 3px 6px 4px 6px;
  color: #FFF;
  text-align: center;
  font-family: "Arial";
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.switch {
  display: inline-block;
  height: 23px;
  position: relative;
  width: 41px;
}

.switch input {
  display: none;
}

.slider {
  background-color: #F4F5F5;
  bottom: 0;
  cursor: pointer;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  transition: background-color 3s;
}

.slider:before {
  position: absolute;
  content: "";
  bottom: 4px;
  left: 4px;
  height: 15px;
  width: 15px;
  background-color: #292C32;
  filter: drop-shadow(0px 0px 5.5px rgba(0, 0, 0, 0.25));
  transition: background-color 3s, transform 3s;
}

.activate-sherpa-container .switch input:checked + .slider {
  background-color: #fff;
}

.activate-sherpa-container .switch input:checked + .slider:before {
  background-color: #FE5E2C;
  transform: translateX(18px);
  filter: drop-shadow(0px 0px 5.5px rgba(0, 0, 0, 0.25));
}

.slider.round {
  border-radius: 38px;
}

.slider.round:before {
  border-radius: 50%;
}`, "",{"version":3,"sources":["webpack://./src/app/people/components/mobile/people-full-view/mobile-people-full-view.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,iBAAA;EACA,0BAAA;AACJ;;AAEA;EACI,uBAAA;AACJ;;AAEA;EACI,gCAAA;AACJ;;AAEA;EACI,cAAA;EACA,gBAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,iBAAA;EACA,yBAAA;EACA,SAAA;EACA,UAAA;AACJ;;AAEA;EACI,iBAAA;EACA,eAAA;AACJ;;AAEA;EACI,cAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AACJ;;AAEA;EACI,mBAAA;EACA,YAAA;EACA,iBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AACJ;;AAEA;EACI,8BAAA;AACJ;;AAEA;EACI,8BAAA;AACJ;;AAEA;EACI,8BAAA;AACJ;;AAEA;EACI,8BAAA;AACJ;;AAEA;EACI,8BAAA;AACJ;;AAEA;EACI,uCAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,iBAAA;EACA,yBAAA;EACA,aAAA;EACA,cAAA;EACA,WAAA;AACJ;;AAEA;EACI,eAAA;EACA,cAAA;EACA,mBAAA;AACJ;;AAEA;EACI,WAAA;EACA,eAAA;AACJ;;AAEA;EACI,kBAAA;EACA,SAAA;AACJ;;AAEA;EACI,kBAAA;EACA,UAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,kBAAA;EACA,WAAA;AACJ;;AAEA;EACI,qBAAA;AACJ;;AAEA;EACI,eAAA;EACA,mBAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,SAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,sCAAA;EACA,wBAAA;AACJ;;AAGA,+CAAA;AAGA;EACI,kBAAA;EACA,mBAAA;AAFJ;;AAIA;EAEI,kBAAA;EACA,0BAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;AAFJ;AAGI;EACI,oBAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AADR;AAEQ;EACI,gBAAA;AAAZ;AAGI;EACI,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;EACA,mBAAA;EACA,sBAAA;EACA,4GAAA;EACA,wBAAA;EACA,WAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AADR;;AAMA;EACI,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AAHJ;;AAME;EACE,aAAA;AAHJ;;AAME;EACE,yBAAA;EACA,SAAA;EACA,eAAA;EACA,OAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,+BAAA;AAHJ;;AAME;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,sDAAA;EAEA,6CAAA;AAJJ;;AAOE;EACE,sBAAA;AAJJ;;AAOE;EACE,yBAAA;EACA,2BAAA;EACA,sDAAA;AAJJ;;AAQE;EACE,mBAAA;AALJ;;AAQE;EACE,kBAAA;AALJ","sourcesContent":["h2 {\n    margin-bottom: 0;\n    padding-bottom: 0;\n    color: rgba(0, 0, 0, 0.57);\n}\n\nh2.ngorange {\n    color: rgb(227, 94, 36);\n}\n\n.fullView-wrapper {\n    padding-bottom: 200px !important;\n}\n\n#recordTypeSubTitle {\n    font-size: 8pt;\n    margin-top: -3px;\n}\n\n.panelHr {\n    margin: 12px;\n}\n\n.name {\n    font-size: 1.4rem;\n    text-transform: uppercase;\n    margin: 0;\n    padding: 0;\n}\n\n.graph-container {\n    min-height: 605px;\n    max-width: 100%;\n}\n\n.cardEvaluationTitle {\n    font-size: 85%;\n    text-align: center;\n    margin: 0;\n    padding: 0;\n}\n\n.activeTab {\n    background: #dddddd;\n    padding: 5px;\n    font-size: 1.3rem;\n}\n\n.reportStatus {\n    padding-top: 20px;\n    text-align: center;\n}\n\n::ng-deep .reportStatus .mat-mini-fab {\n    width: 50px;\n    height: 50px;\n    color: #ffffff;\n    font-size: 2rem;\n    padding-top: 2px;\n}\n\n.mat-greenIcon {\n    background: #78c7af !important;\n}\n\n.mat-redIcon {\n    background: #f07b7e !important;\n}\n\n.mat-yellowIcon {\n    background: #efce7c !important;\n}\n\n.mat-darkGrayIcon {\n    background: #848484 !important;\n}\n\n.mat-grayIcon {\n    background: #cccccc !important;\n}\n\n.mat-orangeIcon {\n    background: rgb(227, 94, 36) !important;\n}\n\n.prbDate {\n    padding: 0 5px;\n}\n\n#iacBox {\n    background: white;\n    border: 4px solid #cecece;\n    padding: 20px;\n    margin: 10px 0;\n    width: 100%;\n}\n\n.resultBlock {\n    font-size: 14pt;\n    padding: 7px 0;\n    margin-bottom: 10px;\n}\n\n.clear {\n    clear: both;\n    display: inline;\n}\n\n.alignLeft {\n    position: absolute;\n    left: 2px;\n}\n\n.alignRight {\n    position: absolute;\n    right: 2px;\n}\n\n.floatLeft {\n    float: left;\n}\n\n.floatRight {\n    float: right;\n}\n\n.dateDiv {\n    position: absolute;\n    right: 17px;\n}\n\n.loaderSpan {\n    display: inline-block;\n}\n\n.satelliteDescription {\n    font-size: 1rem;\n    text-align: justify;\n}\n\n.reportWrapper {\n    margin-bottom: 0px;\n}\n\n.footer {\n    bottom: 0;\n}\n\n::ng-deep .satelliteJobsChoice .mat-form-field {\n    width: 233px;\n}\n\n::ng-deep .mat-grid-tile.person-name-left-align > .mat-grid-tile-content {\n    justify-content: flex-start !important;\n    padding: 17px !important;\n}\n\n\n/******************************************** */\n// Bouton SHERPA\n//******************************************** */\n.sherpa-padding {\n    padding-left: 17px;\n    padding-right: 17px;\n}\n.activate-sherpa-container {\n    // border: 1px solid #000;\n    position: relative;\n    padding: 6px 10px 6px 17px;\n    border-radius: 2px;\n    background: #4D5056;\n    width: 100%;\n    margin: 0 auto;\n    .activate-sherpa-text {\n        font-family: 'Arial';\n        color: #fff;\n        font-size: 15px;\n        line-height: 24px;\n        padding: 4px 0;\n        .bold-jil {\n            font-weight: 700;\n        }\n    }\n    .sherpa-nouveau {\n        position: absolute;\n        margin-top: 16px;\n        top: -29px;\n        left: 12px;\n        border-radius: 18px;\n        border: 1px solid #FFF;\n        background: radial-gradient(221.49% 177.12% at -46.77% 47.5%, #DFDAD4 10.96%, #FE5E2C 48.6%, #575757 99.99%);\n        padding: 3px 6px 4px 6px;\n        color: #FFF;\n        text-align: center;\n        font-family: 'Arial';\n        font-size: 11px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n        \n    }\n}\n\n.switch {\n    display: inline-block;\n    height: 23px;\n    position: relative;\n    width: 41px;\n  }\n  \n  .switch input {\n    display:none;\n  }\n  \n  .slider {\n    background-color: #F4F5F5;\n    bottom: 0;\n    cursor: pointer;\n    left: 0;\n    position: absolute;\n    right: 0;\n    top: 0;\n    transition: background-color 3s;\n  }\n  \n  .slider:before {\n    position: absolute;\n    content: \"\";\n    bottom: 4px;\n    left: 4px;\n    height: 15px;\n    width: 15px;\n    background-color: #292C32;\n    filter: drop-shadow(0px 0px 5.5px rgba(0, 0, 0, 0.25));\n\n    transition: background-color 3s, transform 3s;\n  }\n  \n  .activate-sherpa-container .switch input:checked + .slider {\n    background-color: #fff;\n  }\n  \n  .activate-sherpa-container .switch input:checked + .slider:before {\n    background-color: #FE5E2C;\n    transform: translateX(18px);\n    filter: drop-shadow(0px 0px 5.5px rgba(0, 0, 0, 0.25));\n\n  }\n  \n  .slider.round {\n    border-radius: 38px;\n  }\n  \n  .slider.round:before {\n    border-radius: 50%;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
